import React from "react";
import {Box, Container, Stack} from "@mui/material";
import './style.scss'
import {
    DataProcessingConsentLink,
    DataProcessingPolicyConsentLink,
    DataTransferConsentLink,
    PhoneLink,
    SocialLink
} from "./components";

const Footer = () => {

    return (
        <footer className={'footer'}>
            <Container maxWidth={'xl'}>
                <Box className={'footer__inner'}>
                    <Box className={'footer__policy'}
                    >
                        <DataProcessingConsentLink/>
                        <DataTransferConsentLink/>
                        <DataProcessingPolicyConsentLink/>
                    </Box>
                    <Stack
                        direction={"row"}
                        spacing={2}
                        alignItems={"center"}
                        justifyItems={"center"}
                    >
                        <PhoneLink/>
                        <SocialLink/>
                    </Stack>
                </Box>
            </Container>
        </footer>
    )
}

export default Footer;